import statesModule from './modules/states';
import tableModule from './modules/table';

const state = {
  ...statesModule.state,
  ...tableModule.state,
  serviceName: 'projection_states',
};

const getters = {
  ...statesModule.getters,
  ...tableModule.getters,
};

const actions = {
  ...statesModule.actions,
  ...tableModule.actions,
};

const mutations = {
  ...statesModule.mutations,
  ...tableModule.mutations,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
